import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Avatar, Container, Card, Button, TextField, Typography, FormControl, CardContent, CardHeader, Dialog , TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, Link, Checkbox, List, ListItem, Chip, Box, DialogTitle, DialogContent,DialogActions } from '@mui/material';
import { Attachment as AttachmentIcon, Visibility as VisibilityIcon, Link as LinkIcon, MailOutline as MailOutlineIcon, Settings as SettingsIcon } from '@mui/icons-material';
import CompanyLogo from '../CompanyLogo';
import Linkedin from '@mui/icons-material/LinkedIn';
import { useAuth } from '../AuthContext';

const LinkedInReachOuts = ({ decisionMakers = [], Project, fetchDecisionMakers }) => {
    const { user } = useAuth();
    const [reason, setReason] = useState("");
    const [selectedDecisionMakers, setSelectedDecisionMakers] = useState([]);
    const [status, setStatus] = useState(() => localStorage.getItem('statussss') || "Send Connection Request");
    const DueDays =0;
    const filterstatus = {
        "Send Connection Request": ["Initial Outreach Pending"], 
        "First Outreach": ["Initial Outreach"], 
        "Followup": ["Follow up"], 
        "Second Followup": ["Closing Outreach"], 
        "Response Received": ["Response Received", "Positive Outcome", "Negative Outcome"],        
        "Rejected": ["Rejected"]
    };
    const nextStatus = {
        "Initial Outreach Pending": "Send Connection Request",
        "Send Connection Request": "Initial Outreach",
        "Initial Outreach": "Follow up",
        "Follow up": "Closing Outreach",
        "Closing Outreach": "Response Received",
        "Response Received": "Positive Outcome",
        "Rejected": "Initial Outreach Pending"
    };
    useEffect(() => {
        localStorage.setItem('statussss', status);
    }, [status]);

    const [openModal, setOpenModal] = useState(false);
    const [ModalDMId, setModalDMId] = useState('');
    const [ModalStatus, setModalStatus] = useState('');
    const [newComment, setNewComment] =useState('');

        useEffect(() => {
            console.log(newComment);
        },[newComment]);
    
   

    const handleCloseModal = () => {
        setOpenModal(false);
    } 

    
    const UpdateStatus = async (candidateId, Status) => {
        try {
            // Update connection status
            await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                ExecEdgeId: Project._id,
                candidateId: candidateId,
                Status: Status,
            });    
            // Refresh data and close the modal
            fetchDecisionMakers();
            setOpenModal(false);
        } catch (error) {
            console.error('Error updating connection status:', error);
        }
    };
    

    const handleSubmit = async (newComment) => {
        try {
            // Update connection status
            await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                ExecEdgeId: Project._id,
                candidateId: ModalDMId,
                Status: ModalStatus,
            });
    
            // Push the entire comment block to the backend
            await axios.post('/api/execedge/addAssoComment', {
                execEdgeId: Project._id, // Ensure consistency with backend parameter names
                decisionMakerId: ModalDMId,
                comment: newComment, // Pass the full comment block
            });
    
            // Refresh data and close the modal
            fetchDecisionMakers();
            setOpenModal(false);
        } catch (error) {
            console.error('Error updating connection status:', error);
        }
    };
    


    const handleStatus = async (candidateId, Status) => {
        setOpenModal(true);
        setModalDMId(candidateId);
        setModalStatus(Status);
    }
    const bulkStatusUpdate = async (Status) => {
        try {
            await Promise.all(selectedDecisionMakers.map(async (element) => {
                // Update connection status
                await axios.post('/api/execedge/updateConnectionStatusByEmail', {
                    ExecEdgeId: Project._id,
                    candidateId: element,
                    Status: nextStatus(Status),
                });
            }));
        } catch (error) {
            console.error('Error updating connection status:', error);
        }
    
        // Refresh data and close the modal
        fetchDecisionMakers();
        setSelectedDecisionMakers([]);
    }   

    return (
        <Container>
            {/* Filters */}
                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={2}>
                            <Box display="flex" justifyContent="left" gap={1} width="70%">
                        {["Send Connection Request", "First Outreach", "Followup", "Second Followup", "Response Received","Rejected"].map((state) => (
                            <Button
                                key={state}                                                
                                variant="contained"
                                color={status == state ? "info" : "inherit"} 
                                size="small"    
                                onClick={() => {
                        setStatus(state);  
                        setSelectedDecisionMakers([]);                                           
                    }}
                >
                    {state} ({decisionMakers.filter(dm => filterstatus[state].includes(dm.status)).length})
                </Button>
            ))}
            </Box>            
            </Box>

           

            <TableContainer component={Paper}>
                        {(selectedDecisionMakers.length > 0) && (
                            <Box display="flex" justifyContent="center" alignItems="center" mt={2} mb={2} 
                            sx={{
                            padding: 2,
                            border: "1px solid #ececec",
                            borderRadius: "8px",
                            fontSize: "0.9rem",
                            lineHeight: 1.5,
                            overflowWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            }}>
                                {selectedDecisionMakers.length} Decision Makers selected. <Button variant="contained" onClick={() => bulkStatusUpdate(status)}> {nextStatus[status]}</Button>
                            </Box>
                        )}

                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>
                                            <Checkbox
                                                checked={
                                                    ["Followup Pending","Closing Outreach Pending"].includes(status) ?                                                                                                        
                                                    (selectedDecisionMakers.length === decisionMakers.filter(dm => filterstatus[status].includes(dm.status) && new Date(dm.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))).length && decisionMakers.filter(dm => filterstatus[status].includes(dm.status) && new Date(dm.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))).length > 0)
                                                    : (selectedDecisionMakers.length === decisionMakers.filter(dm => filterstatus[status].includes(dm.status)).length && decisionMakers.filter(dm => filterstatus[status].includes(dm.status)).length > 0) 
                                                }
                                                onChange={(e) => {
                                        if (e.target.checked && [ "Followup Pending", "Closing Outreach Pending"].includes(status) ) {
                                            setSelectedDecisionMakers(decisionMakers.filter(dm => filterstatus[status].includes(dm.status) && new Date(dm.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))).map(dm => dm._id ));
                                        } 
                                        else if (e.target.checked) {
                                            
                                                setSelectedDecisionMakers(decisionMakers.filter(dm => filterstatus[status].includes(dm.status)).map(dm => dm._id ));
                                            }
                                            else {
                                            setSelectedDecisionMakers([]);
                                        }
                                    }}
                                />
                            </TableCell>
                            <TableCell>Added on</TableCell>
                            <TableCell>Company</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Status</TableCell>
                            {([ "Followup Pending", "Closing Outreach Pending"].includes(status)) && (
                            <TableCell>Next Followup</TableCell>)}
                            {([ "Followup Pending", "Closing Outreach Pending","Outreach Completed", "Response Received"].includes(status)) && (
                            <TableCell>Email Status</TableCell>)}
                            <TableCell>Action</TableCell>                            
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { 
                        decisionMakers.filter(dm => filterstatus[status].includes(dm.status)).map(dm => dm._id).map((decisionMakerId) => {
                            const decisionMaker = decisionMakers.find(dm => dm._id === decisionMakerId);
                            if (!decisionMaker || !decisionMaker.candidateId) return null;
                            const company = Project.TargetCompany.find(tc => tc.Organization === decisionMaker.TargetCompanyId);
                            return (
                                <TableRow key={decisionMaker._id}>
                                    <TableCell>{decisionMaker.workEmail}
                                        <Checkbox
                                            checked={selectedDecisionMakers.includes(decisionMaker._id)}
                                            disabled={!(["Initial Outreach Pending"].includes(status) || (new Date(decisionMaker.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))))}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedDecisionMakers([...selectedDecisionMakers, decisionMaker._id]);
                                                } else {
                                                    setSelectedDecisionMakers(selectedDecisionMakers.filter(id => id !== decisionMaker._id));
                                                }
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>{new Date(decisionMaker.createdAt).toLocaleDateString()}</TableCell>
                                    <TableCell>
                                        <CompanyLogo companyName={company?.Name || ""} sx={{ width: '60px', height: '60px' }} />
                                        <br/>
                                        {company ? company.Name : 'Unknown'}
                                    </TableCell>
                                    <TableCell>
                                    {decisionMaker.candidateId?.linkedin ? (
                                        <Link href={decisionMaker.candidateId.linkedin} target="_blank" rel="noopener">
                                            <div style={{display: 'flex', alignItems: 'center'}}>
                                            <Avatar
                                            src= {decisionMaker.candidateId?.dp}
                                            sx={{ width: 50, height: 50, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}
                                            />
                                            <div style={{marginLeft: '10px'}}>
                                            {decisionMaker.candidateId?.name || 'Unknown'}
                                            <br/>{decisionMaker.Designation}
                                            <Linkedin />
                                            </div>
                                            </div>
                                        </Link>
                                    ) : (
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <Avatar
                                            src= {decisionMaker.candidateId?.dp}
                                            sx={{ width: 50, height: 50, boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)' }}
                                            />
                                            <div style={{marginLeft: '10px'}}>
                                            {decisionMaker.candidateId?.name || 'Unknown'}
                                            <br/>{decisionMaker.Designation}
                                            </div>
                                        </div>
                                    )}
                                    </TableCell>
                                    <TableCell>
                                        {decisionMaker.status === "Initial Outreach" ? "Followup Pending" : 
                                         decisionMaker.status === "Follow up" ? "Closing Outreach Pending" : 
                                         decisionMaker.status}
                                    </TableCell>                                    
                                    {([ "Followup Pending", "Closing Outreach Pending"].includes(status)) && (
                                    <TableCell>
                                        {(() => {
                                            const daysDifference = Math.floor((new Date() - new Date(decisionMaker.updatedAt)) / (1000 * 60 * 60 * 24)) - DueDays;
                                            if (daysDifference > 0) {
                                                return `${daysDifference} Days overdue`;
                                            } else if (daysDifference < 0) {
                                                return `After ${Math.abs(daysDifference)} Days`;
                                            } else if (daysDifference === 0) {
                                                return "Today";
                                            }
                                        })()}
                                    </TableCell>
                                )}
                                
                                    <TableCell align="center">
                                        {(new Date(decisionMaker.updatedAt) <= new Date(new Date().setDate(new Date().getDate() - DueDays))) && (
                                            <>
                                            { (["Initial Outreach Pending"].includes(decisionMaker.status) && decisionMaker.candidateId?._id)&& (
                                                <Button variant="contained" color="primary" size="small" sx={{ width: '80%' }}
                                                    onClick={() => { UpdateStatus(decisionMaker.candidateId._id, "Initial Outreach") }}>
                                                        Connection Request Sent</Button> )}
                                            { (["Initial Outreach"].includes(decisionMaker.status) && decisionMaker.candidateId?._id)&& (
                                                <Button variant="contained" color="primary" size="small" sx={{ width: '80%' }}
                                                    onClick={() => { UpdateStatus(decisionMaker.candidateId._id, "Follow up") }}>
                                                        First Outreach</Button> )}
                                            { (["Follow up"].includes(decisionMaker.status) && decisionMaker.candidateId?._id)&& (
                                                <Button variant="contained" color="primary" size="small" sx={{ width: '80%' }}
                                                    onClick={() => { UpdateStatus(decisionMaker.candidateId._id, "Closing Outreach") }}>
                                                        Second Followup</Button> )}
                                                {!["Initial Outreach Pending","Initial Outreach","Response Received"].includes(decisionMaker.status) && decisionMaker.candidateId?._id && (
                                                    <Button 
                                                        variant="outlined"
                                                        color="primary"
                                                        sx={{ width: '80%' }}
                                                        size="small"
                                                        onClick={() => handleStatus(decisionMaker.candidateId._id, "Response Received")}
                                                    >Mark Response Received?
                                                    </Button>
                                                )}
                                                {decisionMaker.status === "Initial Outreach Pending" && decisionMaker.candidateId?._id && (
                                                    <Button 
                                                        variant="contained"
                                                        color="error"
                                                        sx={{ width: '80%' }}
                                                        size="small"
                                                        onClick={() => handleStatus(decisionMaker.candidateId._id, "Rejected")}
                                                    >
                                                        Reject Lead
                                                    </Button>
                                                )}
                                            </>
                                        )}
                                        {decisionMaker.status === "Outreach Completed" && decisionMaker.candidateId?._id && (
                                            <Button 
                                                variant="contained"
                                                color="success"
                                                sx={{ width: '80%' }}
                                                size="small"
                                                onClick={() => handleStatus(decisionMaker.candidateId._id, "Response Received")}
                                            >
                                                Response Received?
                                            </Button>
                                        )}
                                        {decisionMaker.status === "Response Received" && decisionMaker.candidateId?._id && (
                                            <>
                                                <Button 
                                                    variant="contained"
                                                    color="success"
                                                    sx={{ width: '80%' }}
                                                    size="small"
                                                    onClick={() => handleStatus(decisionMaker.candidateId._id, "Positive Outcome")}
                                                >
                                                    Positive Outcome
                                                </Button>
                                                <Button 
                                                    variant="contained"
                                                    color="warning"
                                                    sx={{ width: '80%' }}
                                                    size="small"
                                                    onClick={() => handleStatus(decisionMaker.candidateId._id, "Negative Outcome")}
                                                >
                                                    Negative Outcome
                                                </Button>
                                            </>
                                        )}
                                        {decisionMaker.status === "Rejected" && decisionMaker.candidateId?._id && (
                                            <Button 
                                                variant="contained"
                                                color="success"
                                                sx={{ width: '80%' }}
                                                size="small"
                                                onClick={() => handleStatus(decisionMaker.candidateId._id, "Initial Outreach Pending")}
                                            >
                                                Send for Outreach
                                            </Button>
                                        )}
                                    </TableCell>
                                                        
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>                    

      
            <Dialog open={openModal} onClose={handleCloseModal}>
                    <DialogTitle>Tell us more</DialogTitle>
                    <DialogContent>
                        <TextField
                            label=""
                            value= {reason}
                            onChange={(e) => {
                                setReason(e.target.value);
                                setNewComment({
                                    comment: ModalStatus + " : " + e.target.value,
                                    user: Project._id,
                                    userName: user.name,
                                    timestamp: new Date()
                                });
                                
                            }}                          
                            fullWidth
                            multiline
                            rows={4}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseModal}>Cancel</Button>
                        <Button onClick={() => handleSubmit(newComment)}  color="primary">Submit</Button>
                    </DialogActions>
                </Dialog>
        </Container>
    );
}

export default LinkedInReachOuts;